package com.milta.core.location

/**
 * Kotlin/JS implementation of [LocationProvider] — stub. The web dashboard (`:webApp`) is a
 * Manager/Enterprise surface, not the Driver route-in-progress screen this is built for — always
 * reports "unavailable" rather than wiring the browser Geolocation API for a screen that doesn't
 * exist on this target.
 */
class JsLocationProvider : LocationProvider {
    override suspend fun getCurrentLocation(): GeoPosition? = null
}
